import React, { useEffect, useState } from 'react';
import useSmoothHorizontalScroll from 'use-smooth-horizontal-scroll';
import {ThemeFab} from './ThemeButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ScrollableContent from './ScrollableContent';

function Scrollable({id = null, hasButtonStart = true, hasButtonEnd = true, captureVerticalWheel = true}) {
 
    const { scrollContainerRef, handleScroll, scrollTo, } = useSmoothHorizontalScroll();
    const [isAtStart, setIsAtStart] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);
    const [ scrollContainerWidth, setScrollContainerWidth] = useState(null);

    const handleIsAtStart = () => { 
        scrollTo(-scrollContainerWidth);
        setIsAtStart(true);
        setIsAtEnd(false);
    }

    const handleIsAtEnd = () => { 
        scrollTo(scrollContainerWidth);
        setIsAtEnd(true);
        setIsAtStart(false);

    }

    useEffect(()=> {
        scrollContainerRef.current.addEventListener('wheel', (event) => {
            
            const offset = 60;
            const rightBoundary = scrollContainerRef.current.scrollLeft + scrollContainerRef.current.offsetWidth;

            scrollContainerRef.current.scrollLeft <= offset ? setIsAtStart(true) : setIsAtStart(false);
            rightBoundary >= (scrollContainerWidth - offset) ? setIsAtEnd(true) : setIsAtEnd(false);
          

            if(true === captureVerticalWheel) {
                scrollContainerRef.current.scrollLeft += event.deltaY / 1.5;
            }
        });
    },[scrollContainerRef, captureVerticalWheel,scrollContainerWidth]);
    
    return (
        <div id={id}>
            {(hasButtonStart || hasButtonStart) && 
                <div className={`fixed h-[53px] w-auto flex items-center gap-4 top-0 transition-all duration-500  ${isAtStart ? "left-[140px]" : "left-[74px]"} z-[1000]`}>
                    {hasButtonStart && <ThemeFab onClick={() => handleIsAtStart()} disabled={isAtStart} color="default" variant="extended" size="small" aria-label="Start">
                        <ArrowBackIosIcon fontSize="inherit" />
                        <span className="pr-2 leading-[14px]">Intro</span>
                    </ThemeFab>}
                    {hasButtonEnd && <ThemeFab onClick={() => handleIsAtEnd()} disabled={isAtEnd} color="default" variant="extended" size="small" aria-label="End">
                        <span className="pl-2 leading-[14px]">Outro</span>
                        <ArrowForwardIosIcon fontSize="inherit"/>
                    </ThemeFab>}
                </div>
            }
            <div onScroll={handleScroll} ref={scrollContainerRef} className="overflow-scroll">
                <ScrollableContent setScrollContainerWidth={setScrollContainerWidth} />
            </div>
        </div>
    )
}

export default Scrollable;